import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { usePermissions } from "@/hooks/use-permissions";
import { PageContentSkeleton } from "@/components/shared/page-content-skeleton";

/**
 * Route-level gate for the Speak Agents surface. Renders the `/agents/*` routes only when the
 * company's `voiceAgent.enabled` feature is on, matching the nav gate
 * (menu `requiresFeature: "voiceAgent.enabled"`); otherwise redirects to Home so the agent
 * configuration can't be reached by direct URL when the flag is off.
 */
export function VoiceAgentRouteGuard() {
  const { isLoading } = useAuth();
  const { voiceAgentEnabled } = usePermissions();
  if (isLoading) return <PageContentSkeleton variant="grid" />;
  return voiceAgentEnabled ? <Outlet /> : <Navigate to="/home" replace />;
}
